import { DataSource, HorizontalSpacer, Layout, LayoutHeader, Panel, SearchButton, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutUnbilledOrders extends Layout {
    horizontalspacer1: HorizontalSpacer;
    layoutheaderUnbilledOrders: LayoutHeader;
    panelSearchContainer: Panel;
    searchbuttonSearch: SearchButton;
    sourceExpandedOrder: DataSource;
    sourceOrders: DataSource;
    tableUnbilledOrders: Table;
    textboxStopConsigneeactualDeparture: Textbox;
}
